import { library } from '@fortawesome/fontawesome-svg-core'
//  import { fas } from '@fortawesome/free-brands-svg-icons'
import { faArrowCircleRight, faCoffee, faSpinner} from '@fortawesome/free-solid-svg-icons'


library.add( faArrowCircleRight, faCoffee, faSpinner)